import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Terms() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <Header />

      <div className="policy-page">
        <div className="policy-hero">
          <h1>Terms & Conditions</h1>
          <p>
            By accessing and using our website, you agree to comply with the
            following terms and conditions.
          </p>
        </div>

        <div className="policy-container">
          <section className="policy-card">
            <h2>1. General Use</h2>
            <p>
              You agree to use this website only for lawful purposes and in a
              manner that does not violate any applicable laws or regulations.
            </p>
          </section>

          <section className="policy-card">
            <h2>2. Products & Availability</h2>
            <p>
              We reserve the right to modify, discontinue, or limit product
              availability without prior notice.
            </p>
          </section>

          <section className="policy-card">
            <h2>3. Pricing</h2>
            <p>
              Prices displayed on the website are subject to change at any time.
              We are not responsible for typographical pricing errors.
            </p>
          </section>

          <section className="policy-card">
            <h2>4. Orders</h2>
            <p>
              We reserve the right to cancel or refuse any order if fraudulent,
              unauthorized, or suspicious activity is detected.
            </p>
          </section>

          <section className="policy-card">
            <h2>5. Intellectual Property</h2>
            <p>
              All website content including logos, graphics, text, and product
              images are protected by intellectual property laws and may not be
              copied without permission.
            </p>
          </section>

          <section className="policy-card">
            <h2>6. Limitation of Liability</h2>
            <p>
              We are not liable for any indirect, incidental, or consequential
              damages arising from the use of this website or products purchased
              through it.
            </p>
          </section>

          <section className="policy-card">
            <h2>7. External Links</h2>
            <p>
              Our website may contain links to third-party websites. We are not
              responsible for the content or privacy practices of those sites.
            </p>
          </section>

          <section className="policy-card">
            <h2>8. Changes to Terms</h2>
            <p>
              We reserve the right to update these Terms & Conditions at any
              time without prior notice.
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Terms;
